// extracted by mini-css-extract-plugin
export default {"self-signing-disclaimer":"styles_self-signing-disclaimer__Ludd1"};